exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@-webkit-keyframes StopScreenDialog_fadeIn__1n-qT {\n  0% {\n    opacity: 0; }\n  100% {\n    opacity: 1; } }\n\n@keyframes StopScreenDialog_fadeIn__1n-qT {\n  0% {\n    opacity: 0; }\n  100% {\n    opacity: 1; } }\n\n@-webkit-keyframes StopScreenDialog_fadeOut__WU0Un {\n  0% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n\n@keyframes StopScreenDialog_fadeOut__WU0Un {\n  0% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n\n.StopScreenDialog_content__2EG66 .StopScreenDialog_overlay__3hWFE {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  display: -webkit-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n          flex-direction: column;\n  -webkit-align-items: center;\n          align-items: center;\n  -webkit-justify-content: center;\n          justify-content: center;\n  display: none; }\n\n.StopScreenDialog_content__2EG66.StopScreenDialog_busy__dEP7G {\n  overflow: hidden !important; }\n  .StopScreenDialog_content__2EG66.StopScreenDialog_busy__dEP7G .StopScreenDialog_questions__1HoAR {\n    pointer-events: none;\n    opacity: 0.4; }\n  .StopScreenDialog_content__2EG66.StopScreenDialog_busy__dEP7G .StopScreenDialog_overlay__3hWFE {\n    display: -webkit-flex;\n    display: flex; }\n", ""]);

// exports
exports.locals = {
	"color": "#ff3b00",
	"colorSecondary": "#4caf50",
	"colorContrastText": "#ffffff",
	"colorLight": "#ff7349",
	"colorDark": "#ce3000",
	"colorSecondaryLight": "#81c784",
	"colorSecondaryDark": "#388e3b",
	"hostColor": "#eb8315",
	"hostColorSecondary": "#f44336",
	"hostColorContrastText": "#ffffff",
	"hostColorLight": "#ffa74a",
	"hostColorDark": "#cf6a00",
	"content": "StopScreenDialog_content__2EG66",
	"overlay": "StopScreenDialog_overlay__3hWFE",
	"busy": "StopScreenDialog_busy__dEP7G",
	"questions": "StopScreenDialog_questions__1HoAR",
	"fadeIn": "StopScreenDialog_fadeIn__1n-qT",
	"fadeOut": "StopScreenDialog_fadeOut__WU0Un"
};